import { React, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';
import FetchModule from '../../../Share/Network/FetchModule';
import { formatPhoneNumber } from '../../../../Utils/phoneUtils';

import UserNameModifyModal from './Modal/UserNameModifyModal';
import DeleteWarningModal from './Modal/DeleteWarningModal';
import UserProfile from '../../../../Component/Normal/UserProfile';

import DefaultProfile from '../../../../image/DefaultProfile.png';

export default function PartnerGymIndividualInfo(props) {
  const { memberData, rendering } = props;

  const history = useHistory();
  const { t, languageMode } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isFocused, setIsFocused] = useState(false);
  const [memberDetail, setMemberDetail] = useState(memberData.memberDetail);
  const [originalDetail, setOriginalDetail] = useState(undefined);
  const [isClickedModifyUserName, setIsClickedModifyUserName] = useState(false);
  const [isClickedDeleteWarning, setIsClickedDeleteWarning] = useState(false);

  // 회원 메모 동기화 //
  useEffect(() => {
    setMemberDetail(memberData.memberDetail);
  }, [memberData])

  // 포커스 시 원본 메모 저장 //
  useEffect(() => {
    if (isFocused) setOriginalDetail(memberDetail);
  }, [isFocused, memberDetail])

  // 회원 삭제 클릭시 //
  function onClickMemberInfoDelete() {
    let requestData = {
      memberId: memberData.memberId
    }

    const fetchModule = new FetchModule();
		(
			async () => {
				const responseData = await fetchModule.postDataVersion2('member/delete', 'POST', requestData);
				if (responseData.status === 200) {
          alert(t('partnerGym.detail.alertDeleted'));
          history.push('/member/valid');
        }
        else if (responseData.status === 201) {
          alert(t('partnerGym.detail.alertInvalidMember'));
          history.push('/member/valid');
        }
        else if (responseData.status === 202) {
          alert(t('partnerGym.detail.alertActiveMembership'));
        }
        else if (responseData.status === 203) {
          alert(t('partnerGym.detail.alertActiveLocker'));
        }
        else if (responseData.status === 204) {
          alert(t('partnerGym.detail.alertMemberNotFound'));
          history.push('/member/valid');
        }
        else if (responseData.status === 401) {
          alert(t('partnerGym.detail.alertLoginRequired'));
          history.push('/');
        }
			}
		)();
  }

  // 취소버튼 누를시
  function onClickExit() {
    setMemberDetail(originalDetail);
    setIsFocused(false);
  }

  // 수정버튼 클릭시
  function onClickModity() {
    let data = {
      storeId: window.sessionStorage.getItem('StoreId'),
      memberId: memberData.memberId,
      memberDetail: memberDetail
    }
    
    const fetchModule = new FetchModule();
		(
			async () => {
				const responseData = await fetchModule.postData('member/modify/member_detail', 'POST', data);
				if (responseData.status === 200) {
          alert(t('partnerGym.detail.alertModifyComplete'));
          setIsFocused(false);
          rendering();
				}
        else if (responseData.status === 400) {
          alert(t('partnerGym.detail.alertNoPermission'));
          history.push('/member/valid');
        }
				else if (responseData.status === 401) {
          alert(t('partnerGym.detail.alertLoginRequired'));
          history.push('/');
        }
			}
		)();
  }

  // 변경된 이름 저장하기 클릭시 //
  function onClickSave(changeName, changeDate, changeGender, changePhone) {
    let data = {
      memberId: memberData.memberId,
      userName: changeName,
      birthDay: changeDate,
      gender: changeGender,
      phone: changePhone
    }
    
    const fetchModule = new FetchModule();
		(
			async () => {
				const responseData = await fetchModule.postData('member/modify/username', 'POST', data);
				if (responseData.status === 200) {
          alert(t('partnerGym.detail.alertModifyComplete'));
          setIsClickedModifyUserName(false);
          rendering();
				}
        else if (responseData.status === 201) {
          alert(t('partnerGym.detail.alertNoPermission'));
          history.push('/member/valid');
        }
				else if (responseData.status === 401) {
          alert(t('partnerGym.detail.alertLoginRequired'));
          history.push('/');
        }
			}
		)();
  }

  return (
    <TopLevelWrapper>
      { 
        isClickedModifyUserName && 
        <UserNameModifyModal 
          userName={memberData.name} 
          birthDay={memberData.birthDay} 
          gender={memberData.gender} 
          phone={memberData.phone}
          onClickSave={onClickSave} 
          onClickClose={() => setIsClickedModifyUserName(false)}/> 
      }
      { isClickedDeleteWarning && <DeleteWarningModal onClickExit={() => setIsClickedDeleteWarning(false)} onClickDelete={onClickMemberInfoDelete}/> }
      <UserPhotoWrapper isDark={isDark}>
        <UserProfile profile={memberData.profile} defaultProfile={DefaultProfile} />
      </UserPhotoWrapper>
      <UserInfoView isDark={isDark}>
        <InfoBoxWrapper>
          <UserNameWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{memberData.name}</Text>
            {t('partnerGym.detail.member') !== '' && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>&nbsp;{t('partnerGym.detail.member')}</Text>}
          </UserNameWrapper>
          <InfoGridWrapper>
            <InfoItem>
              <InfoLabel><Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.detail.gender')}</Text></InfoLabel>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{memberData.gender === 'male' ? t('partnerGym.male') : t('partnerGym.female')}</Text>
            </InfoItem>
            <InfoItem>
              <InfoLabel><Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.detail.birthDate')}</Text></InfoLabel>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{moment(memberData.birthDay, 'YYYYMMDD').format(t('calendarInput.fullDateFormat'))}</Text>
            </InfoItem>
            <InfoItem>
              <InfoLabel><Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.detail.phone')}</Text></InfoLabel>
              <Text style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{formatPhoneNumber(memberData.phone, memberData.countryCode, languageMode) || t('partnerGym.none')}</Text>
            </InfoItem>
            <InfoItem>
              <InfoLabel><Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.detail.id')}</Text></InfoLabel>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{memberData.nickName}</Text>
            </InfoItem>
            <InfoItem>
              <InfoLabel><Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.detail.partner')}</Text></InfoLabel>
              <PartnerNameText>{memberData.storeName}</PartnerNameText>
            </InfoItem>
          </InfoGridWrapper>
        </InfoBoxWrapper>
        <ColumnLayerWrapper>
          <ExplanationWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.detail.memberNote')}</Text>
            <ButtonWrapper>
              { isFocused && <ExitButton onClick={() => onClickExit()}>{t('partnerGym.detail.cancel')}</ExitButton> }
              { isFocused && <ModifyButton onClick={() => onClickModity()}>{t('partnerGym.detail.modify')}</ModifyButton> }
            </ButtonWrapper>
            </ExplanationWrapper>
            <MemberNoticeWindow>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={memberDetail === '' ? theme.line : theme.subText} cursor='default'>{memberDetail === '' ? t('partnerGym.detail.notePlaceholder') : memberDetail}</Text>
            </MemberNoticeWindow>
        </ColumnLayerWrapper>
      </UserInfoView>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 38px;

  transition: all 0.3s ease-in-out;
`;

const UserPhotoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 229px;
  height: 229px;

  overflow: hidden;

  border: 1px solid ${props => props.theme.line};
  border-radius: 24px;
  box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  background-color: ${props => props.theme.subBackground};
`;

const UserInfoView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 697px;
  height: 229px;

  padding: 0 28px 0 28px;

  box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  border-radius: 20px;
  background-color: ${props => props.theme.subBackground};
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 190px;

  gap: 8px;

  overflow: hidden;
`;

const ColumnLayerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 8px;
`;

const InfoGridWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 6px;
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
`;

const InfoLabel = styled.div`
  width: 60px;
  flex-shrink: 0;
`;

const UserNameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 12px;
`;

const ModifyButton = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subKey};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const ExitButton = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.pointRed};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const MemberNoticeWindow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 16px 16px 16px 16px;
  margin: 0 0 0 0;

  width: 431px;
  height: 98px;

  overflow-x: hidden;
  overflow-y: scroll;

  border: 1px solid ${props => props.theme.line};
  border-radius: 24px;
  background-color: ${props => props.theme.subBackground};

  &::-webkit-scrollbar {
    height: 4px;
    width: 0px;
  }

  &::-webkit-scrollbar-thumb {
    border: 2px solid transparent;
    background-color: ${props => props.theme.scrollBar};
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${props => props.theme.subBackground};
    border-radius: 200px;
  }
`;

const PartnerNameText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  max-width: 140px;
  max-height: 20px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
